import React from "react";

export default function PadlockIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.01445 8.84844V7.64844C8.01445 5.02344 10.2232 3.24219 12.7207 3.24219C15.4245 3.24219 17.427 5.30094 17.427 7.64844V8.84844M12.7207 14.0497V16.8509M4.4707 8.84844H20.9707V20.7547H4.4707V8.84844Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
      <path
        d='M12.7211 14.0516C13.0525 14.0516 13.3211 13.7829 13.3211 13.4516C13.3211 13.1202 13.0525 12.8516 12.7211 12.8516C12.3897 12.8516 12.1211 13.1202 12.1211 13.4516C12.1211 13.7829 12.3897 14.0516 12.7211 14.0516Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
    </svg>
  );
}
